module.exports = __webpack_public_path__ + "img/login_bg.60e46e41.png";